<generic-notification></generic-notification>
<header></header>
<breadcrumb></breadcrumb>
<router-outlet></router-outlet>
<footer></footer>
<cookie-popup></cookie-popup>

<notice-dialog [visible]="agreementModal"
               [style]="{'width': '500px', 'font-size': '15px'}"
               (onClick)="acceptConsent();"
               [showProgress]="showProgressAccept"
               [showActions]="true">
    <ng-template #content>
        <span [innerHTML]="'QSOL_CONSENT_TEXT' | translate:{ termsUrl: ('/info/qsol/terms.html' | resource: 'QSOL_HOST'), privacyUrl: 'https://www.cummins.com/privacy-and-legal' }"></span>
    </ng-template>
</notice-dialog>

<notice-dialog [visible]="sessionEvents.clearCookies"
               [style]="{'width': '400px', 'font-size': '15px'}"
               (onClick)="sessionEvents.clearCookies = false;"
               [showProgress]="false"
               [showActions]="false">
    <ng-template #content>
        {{ 'An issue was detected with your session' | translate }}.
        <br/>
        {{ 'Please clear your browser’s cookies and login again' | translate }}.
    </ng-template>
</notice-dialog>

<notice-dialog [visible]="sessionEvents.showSessionRefreshConfirmation || sessionEvents.showSessionResetNotification || sessionEvents.showWindowInactiveNotification"
               [style]="{'width': '400px', 'font-size': '15px'}"
               (onClick)="sessionEvents.showSessionResetNotification = false; refreshSession(sessionEvents.showSessionRefreshConfirmation || sessionEvents.showWindowInactiveNotification);"
               [showProgress]="sessionEvents.showSessionRefreshConfirmationProgress"
               [showActions]="true">
    <ng-template #content>
        {{ "Click on 'Continue' to keep working" | translate }}.
    </ng-template>
</notice-dialog>